import { Line, Bar, mixins } from "vue-chartjs";
import "chartjs-plugin-zoom";

const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "options"],
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
